<div fxLayout="column" fxLayoutAlign="center center">    
    <h1 class="mat-headline">{{'income-report'| translate}}</h1>
    <h4 class="mat-subheading-1">{{'income-report-description' | translate}}</h4>  
</div>
<div class="container" fxLayout fxLayout.xs="column" fxLayoutAlign="center center" fxLayoutGap="10px"
    fxLayoutGap.xs="0">
    <mat-form-field fxFlex="40">
        <input type="text" placeholder="{{'agent'| translate}}" matInput [formControl]="agentId"
            [matAutocomplete]="auto">
        <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayFn" autoActiveFirstOption (optionSelected)="accountChanged()">
            <mat-option *ngFor="let option of agentAutoComplete$ | async; let index = index" [value]="option">
                {{option.title}}
            </mat-option>
        </mat-autocomplete>
        <button *ngIf="agentId != null" mat-button matSuffix mat-icon-button aria-label="Clear" (click)="clearSearch()">
            <mat-icon>close</mat-icon>
          </button>
    </mat-form-field>

    <mat-form-field>
        <mat-label>{{'dateFrom' | translate}}</mat-label>
        <input matInput [matDatepicker]="pickerFrom" (click)="pickerFrom.open()" [formControl]="dateFrom" placeholder="dateFrom" (dateChange)="dateFromChanged()" readonly>
        <mat-datepicker-toggle matSuffix [for]="pickerFrom"></mat-datepicker-toggle>
        <mat-datepicker #pickerFrom></mat-datepicker>
    </mat-form-field>
    <mat-form-field>
        <mat-label>{{'dateTo' | translate}}</mat-label>
        <input matInput [matDatepicker]="pickerTo"  (click)="pickerTo.open()" [formControl]="dateTo" placeholder="{{'dateFrom'| translate}}" (dateChange)="dateToChanged()" readonly>
        <mat-datepicker-toggle matSuffix [for]="pickerTo"></mat-datepicker-toggle>
        <mat-datepicker #pickerTo></mat-datepicker>
    </mat-form-field>

    <button mat-icon-button color="primary" (click)="getReport()">
        <mat-icon>search</mat-icon>
    </button>

    <button mat-icon-button color="primary" #menuTrigger="matMenuTrigger" [matMenuTriggerFor]="mainMenuButtonExcel" [disabled]="dataSource?.length < 1">
        <mat-icon>save_alt</mat-icon>
    </button>
    <mat-menu #mainMenuButtonExcel="matMenu">
        <div class="table-column-list-block">
            <section class="button-download">
                <button mat-raised-button color="primary"  (click)="exportToExcel()" >
                    {{'export' | translate}}
                    <mat-icon>save_alt</mat-icon>
                </button>   
            </section>
            <span (click)="$event.stopPropagation()" *ngFor="let element of columnDefinitionsForExcel;index as i">
                <mat-slide-toggle color="primary" (change)="element.isShow = !element.isShow" [checked]="element.isShow == true"></mat-slide-toggle>
                {{element.label}}
                <br>
            </span>
        </div>
    </mat-menu>
</div>
<mat-progress-bar mode="indeterminate" *ngIf="!isCompleted"></mat-progress-bar>
<div fxLayout="column" fxLayoutAlign="none">
    <table mat-table [dataSource]="dataSource" class="mat-elevation-z0">

        <!-- date Column -->
        <ng-container matColumnDef="date">
            <th mat-header-cell *matHeaderCellDef> {{'date' | translate}} </th>
            <th mat-header-cell *matHeaderCellDef> </th>
            <td mat-cell *matCellDef="let element"> {{element.date | date: 'dd/MM/yyyy'}} </td>
            <td mat-footer-cell *matFooterCellDef>{{'total' | translate}}</td>
        </ng-container>

        <!-- transactionsCount Column -->
        <ng-container matColumnDef="transactionsCount">
            <th mat-header-cell *matHeaderCellDef> {{'successTransactionCount' | translate}} </th>
            <td mat-cell *matCellDef="let element"> {{element.transactionsCount}} </td>
            <td mat-footer-cell *matFooterCellDef>{{getTotalSuccesTransaction()}} </td>
        </ng-container>

        <!-- allCashFlow Column -->
        <ng-container matColumnDef="allCashFlow">
            <th mat-header-cell *matHeaderCellDef> {{'allCashFlow' | translate}} </th>
            <td mat-cell *matCellDef="let element"> {{element.allCashFlow | currency:globalCurrencyCode:'symbol':'1.2-2':globalLocation}} </td>
            <td mat-footer-cell *matFooterCellDef>{{getTotalAllCashFlow() | currency:globalCurrencyCode:'symbol':'1.2-2':globalLocation}} </td>
        </ng-container>

        <!-- agentsCashFlow Column -->
        <ng-container matColumnDef="agentsCashFlow">
            <th mat-header-cell *matHeaderCellDef> {{'agentsCashFlow' | translate}} </th>
            <td mat-cell *matCellDef="let element"> {{element.agentsCashFlow | currency:globalCurrencyCode:'symbol':'1.2-2':globalLocation}} </td>
            <td mat-footer-cell *matFooterCellDef>{{getTotalAgentsCashFlow() | currency:globalCurrencyCode:'symbol':'1.2-2':globalLocation}} </td>
        </ng-container>

        <!-- subAgentsCashFlow Column -->
        <ng-container matColumnDef="subAgentsCashFlow">
            <th mat-header-cell *matHeaderCellDef> {{'subAgentsCashFlow' | translate}} </th>
            <td mat-cell *matCellDef="let element"> {{element.subAgentsCashFlow | currency:globalCurrencyCode:'symbol':'1.2-2':globalLocation}} </td>
            <td mat-footer-cell *matFooterCellDef>{{getTotalSubAgentsCashFlow() | currency:globalCurrencyCode:'symbol':'1.2-2':globalLocation}} </td>
        </ng-container>

        <!-- itoIncome Column -->
        <ng-container matColumnDef="itoIncome">
            <th mat-header-cell *matHeaderCellDef> {{'itoIncome' | translate}} </th>
            <td mat-cell *matCellDef="let element"> {{element.itoIncome | currency:globalCurrencyCode:'symbol':'1.2-2':globalLocation}} </td>
            <td mat-footer-cell *matFooterCellDef>{{getTotalITOIncome() | currency:globalCurrencyCode:'symbol':'1.2-2':globalLocation}} </td>
        </ng-container>

        <!-- lowerCommissionIncome Column -->
        <ng-container matColumnDef="lowerCommissionIncome">
            <th mat-header-cell *matHeaderCellDef> {{'lowerCommissionIncome' | translate}} </th>
            <td mat-cell *matCellDef="let element"> {{element.lowerCommissionIncome | currency:globalCurrencyCode:'symbol':'1.2-2':globalLocation}} </td>
            <td mat-footer-cell *matFooterCellDef>{{getTotalLowerCommissionIncome() | currency:globalCurrencyCode:'symbol':'1.2-2':globalLocation}} </td>
        </ng-container>
      
        <!-- canceledCount Column -->
        <ng-container matColumnDef="canceledCount">
            <th mat-header-cell *matHeaderCellDef> {{'canceledTransactionCount' | translate}} </th>
            <td mat-cell *matCellDef="let element"> {{element.canceledCount}} </td>
            <td mat-footer-cell *matFooterCellDef>{{getTotalCanceledTransaction()}} </td>
        </ng-container>

        <!-- canceledAmount Column -->
        <ng-container matColumnDef="canceledAmount">
            <th mat-header-cell *matHeaderCellDef> {{'canceledAmount' | translate}} </th>
            <td mat-cell *matCellDef="let element"> {{element.canceledAmount | currency:globalCurrencyCode:'symbol':'1.2-2':globalLocation}} </td>
            <td mat-footer-cell *matFooterCellDef>{{getTotalCanceledAmount() | currency:globalCurrencyCode:'symbol':'1.2-2':globalLocation}} </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>     
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        <tr mat-footer-row *matFooterRowDef="displayedColumns"></tr>
    </table>
</div>